<template>
  <ym-block class="search-result-block"
            :block="block"
            :show-more="showGetMore"
            :show-hide="showHide"
            @show-more="handleGetMore"
            @hide-more="handleHideMore"
  >
    <ym-search-list :type="block.blockType"
                    :list="block.list"
    />
  </ym-block>
</template>

<script>
  import Block from '@/components/Block/IconBlock';
  import List from '@/pages/Search/components/SearchResultList';
  import { getSearchResultList } from '@/services/search';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'SearchResultBlock',
    components: {
      'ym-block': Block,
      'ym-search-list': List,
    },
    data() {
      return {
        initStart: 0,
      };
    },
    props: {
      q: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
      block: {
        type: Object,
        required: true,
      },
    },
    computed: {
      showGetMore() {
        const { block } = this;
        const { start, count } = block;
        return count > start;
      },
      showHide() {
        const { initStart, block } = this;
        const { count } = block;
        return count > initStart;
      },
    },
    watch: {
      block(val) {
        this.storageInitStart(val);
      },
    },
    methods: {
      storageInitStart(block) {
        const { start } = block;
        this.initStart = start;
      },
      async handleGetMore() {
        const { q, type, block } = this;
        const { start, blockType } = block;
        const data = await getSearchResultList({
          q,
          type,
          blockType,
          start,
          limit: LIMIT,
        });
        this.block.list = [...this.block.list, ...data.list];
        this.block.start = data.start;
      },
      handleHideMore() {
        const { initStart, block } = this;
        const { list } = block;
        const { length } = list;
        block.start = initStart;
        list.splice(initStart, length - 1);
      },
    },
    created() {
      const { block } = this;
      this.storageInitStart(block);
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .search-result-block {
    margin-top: 0;
    position: relative;
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: @size-base;
      right: @size-base;
      bottom: 0;
      height: 1px;
      background-color: @border-color-base;
    }
    &:last-child {
      &::after {
        height: 0;
      }
      .block-control {
        border-bottom: 0;
      }
    }
    &.is-show-control {
      padding-bottom: 0;
      &::after {
        height: 0;
      }
    }
  }

  .block-icon {
    color: @color-gray-light;
    font-size: 32px;
    flex-shrink: 0;
    margin-top: -6px;
    margin-right: @size-extra-small;
  }

  .block-control {
    border-top: @border-base;
    border-bottom: @border-base;
    height: 90px;
    line-height: 90px;
    text-align: center;
    box-sizing: border-box;
  }

  .block-control-text {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: @font-size-base;
    color: @color-text-lighter;
    .highlight {
      color: @color-text-primary;
    }
  }

  .control-icon {
    color: @color-gray-light;
    font-size: 22px;
    flex-shrink: 0;
    margin-left: @size-small;
  }

  .icon-up {
    transform: rotate(180deg);
  }
</style>
